import { createContext } from 'react';

export const EventBasicInformationContext =
    createContext<EventBasicInformation | null>(null);

export interface EventBasicInformation {
    id: string;
    name: string;
    summary: string;
    place: {
        isOnline?: boolean;
        latitude?: number;
        longitude?: number;
        placeId?: string;
    };
}
